import { Box, Button, Center, Flex, Heading, Image } from '@chakra-ui/react'
import { useContext } from 'react'

import AxLoginBg from '../../../../public/images/ax_login_bg.svg'
import GoogleIcon from '../../../assets/svgIcons/google_icon.svg'
import { thickBoxShadow } from '../../../chakraTheme'
import HonourCodeStep from '../../../common/HonourCodeStep.jsx'
import { AuthContext } from '../../../contexts/AuthContext'
import AxInstructionsContext from '../../../contexts/AxInstructionsContext'
import AX_INSTRUCTIONS_ACTION from '../../../enums/axInstructionsActions.js'
import AX_INSTRUCTIONS_STATUS from '../../../enums/axInstructionsStatus.js'
import AX_INSTRUCTIONS_STEPS from '../../../enums/axInstructionsSteps'
import ProctoringSetup from '../../../deprecated/Admission/Challenge/components/ProctoringSetup.jsx'
import {
    cacheRegularAssessmentAttemptStorage,
    getRegularAssessmentAttemptStorage,
    REGULAR_ASSESSMENT_SOURCE_FLOW,
} from '../../../utils/regularAssessmentStorage'
import DetailsForm from './DetailsForm'
import IntructionsWithOtp from './IntructionsWithOtp'

const CurrentStepComponent = ({ assessment }) => {
    const { store, dispatch } = useContext(AxInstructionsContext)

    const handlePrevious = () => {
        dispatch({ type: AX_INSTRUCTIONS_ACTION.PREV_STEP })
    }

    const handleNext = () => {
        dispatch({
            type: AX_INSTRUCTIONS_ACTION.UPDATE_CURRENT_STEP_STATUS,
            status: AX_INSTRUCTIONS_STATUS.COMPLETED,
        })
        dispatch({
            type: AX_INSTRUCTIONS_ACTION.NEXT_STEP,
        })
    }

    const onCheckClicked = isChecked => {
        dispatch({
            type: AX_INSTRUCTIONS_ACTION.UPDATE_ABIDE_HONOUR_CODE,
            value: isChecked,
        })
    }

    if (store?.steps && Array.isArray(store.steps))
        switch (store.steps[store.currentStep].name) {
            case AX_INSTRUCTIONS_STEPS.SETUP_TEST_ENVIRONMENT:
                return (
                    <ProctoringSetup
                        dispatch={dispatch}
                        assessment={assessment}
                        cacheAttemptStorage={cacheRegularAssessmentAttemptStorage}
                        getAttemptStorage={getRegularAssessmentAttemptStorage}
                        attemptSourceFlow={REGULAR_ASSESSMENT_SOURCE_FLOW}
                    />
                )
            case AX_INSTRUCTIONS_STEPS.DETAILS_FORM:
                return (
                    <DetailsForm
                        store={store}
                        dispatch={dispatch}
                        isFirstPage={store.currentStep === 0}
                    />
                )
            case AX_INSTRUCTIONS_STEPS.KALVIUM_HONOUR_CODE:
                return (
                    <HonourCodeStep
                        isFirstPage={store.currentStep === 0}
                        isDefaultAgreed={store.abideHonourCode}
                        handleNext={handleNext}
                        handlePrevious={handlePrevious}
                        onCheckClicked={onCheckClicked}
                    />
                )
            case AX_INSTRUCTIONS_STEPS.INSTRUCTIONS:
                return <IntructionsWithOtp />
        }
}

const Steps = ({
    assessment,
    autoSubmitWarningMessage,
    isDisplayWarningMessage,
}) => {
    const { kalviumKc } = useContext(AuthContext)

    const LoginBox = () => {
        return (
            <Box
                boxShadow={thickBoxShadow}
                borderRadius={0}
                borderWidth={3}
                borderColor={'mineshaft'}
                bg={'white'}
                maxW={'349px'}
                maxH={'174px'}
                width={'full'}
                height={'full'}
                pl={'30px'}
            >
                <Heading
                    mt={6}
                    as="h6"
                    fontSize="lg"
                    lineHeight={{
                        base: 6,
                        md: 7,
                    }}
                >
                    Log in to view the <br /> assessment details
                </Heading>
                <Button
                    mt={6}
                    variant="flat"
                    py={'12px !important'}
                    onClick={() => {
                        kalviumKc.doLogin()
                    }}
                >
                    <Box h={6} w={6}>
                        <Image
                            src={GoogleIcon}
                            alt="Google"
                            htmlHeight={24}
                            htmlWidth={24}
                        />
                    </Box>
                    <Heading
                        ml={4}
                        fontSize={{
                            base: 'sm',
                            md: 'md',
                        }}
                        fontWeight="normal"
                        color="codgray"
                    >
                        Continue with Google
                    </Heading>
                </Button>
            </Box>
        )
    }

    return kalviumKc?.isLoggedIn() ? (
        <Box
            width={'full'}
            height={'100%'}
            overflowY={'scroll'}
            marginInlineStart={'0 !important'}
        >
            {autoSubmitWarningMessage && isDisplayWarningMessage && (
                <Box
                    position="fixed"
                    top="0"
                    transform="translateX(-1.5rem)"
                    width="calc(100% + 1.5rem)"
                    bg="#B91C1C"
                    color="white"
                    px={6}
                    py={6}
                    zIndex={1000}
                    display="flex"
                    borderBottom="2px solid #EF4444"
                >
                    {autoSubmitWarningMessage()}
                </Box>
            )}
            <CurrentStepComponent assessment={assessment} />
        </Box>
    ) : (
        <Flex
            width={'55%'}
            height={'100%'}
            bg={`url(${AxLoginBg}) no-repeat center center`}
            bgSize={'cover'}
            marginInlineStart={'0 !important'}
            justify={'center'}
            align={'center'}
        >
            <LoginBox />
        </Flex>
    )
}

export default Steps
